/*----------------------------------
- DOMAINS EMPTY RESULTS PREVIEW ROWS
----------------------------------*/

import type { WebsiteDomainsSearchRow } from '@/common/types/domains/websiteLanding';

/*----------------------------------
- CATALOG
----------------------------------*/

export const EMPTY_DOMAINS_RESULTS_PREVIEW_ROWS: readonly WebsiteDomainsSearchRow[] = [
    {
        id: 'preview-summit-co',
        domain: 'summit.co',
        tld: 'co',
        status: 'premium',
        askPrice: 2792,
        renewal: 28,
        source: 'Registrar',
        resellPrice: 6185,
        spread: 3393,
        compsRepartition: {
            available: 3,
            premium: 1,
            forSale: 0,
            unavailable: 22,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Direct',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'confident',
        spellingRisk: 'low',
    },
    {
        id: 'preview-atlas-ai',
        domain: 'atlas.ai',
        tld: 'ai',
        status: 'available',
        askPrice: 3711,
        renewal: 85,
        source: 'Registrar',
        resellPrice: 8385,
        spread: 4674,
        compsRepartition: {
            available: 3,
            premium: 1,
            forSale: 0,
            unavailable: 24,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Technical',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'precise',
        spellingRisk: 'low',
    },
    {
        id: 'preview-nimbus-io',
        domain: 'nimbus.io',
        tld: 'io',
        status: 'available',
        askPrice: 2418,
        renewal: 42,
        source: 'Registrar',
        resellPrice: 3944,
        spread: 1526,
        compsRepartition: {
            available: 2,
            premium: 3,
            forSale: 1,
            unavailable: 19,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Evocative',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'light',
        spellingRisk: 'low',
    },
    {
        id: 'preview-radius-co',
        domain: 'radius.co',
        tld: 'co',
        status: 'premium',
        askPrice: 1834,
        renewal: 28,
        source: 'Marketplace',
        resellPrice: 3924,
        spread: 2090,
        compsRepartition: {
            available: 2,
            premium: 2,
            forSale: 0,
            unavailable: 21,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Geometric',
        syllables: 3,
        partOfSpeech: 'noun',
        sentiment: 'balanced',
        spellingRisk: 'low',
    },
    {
        id: 'preview-orbit-app',
        domain: 'orbit.app',
        tld: 'app',
        status: 'available',
        askPrice: 1290,
        renewal: 18,
        source: 'Registrar',
        resellPrice: 3260,
        spread: 1970,
        compsRepartition: {
            available: 4,
            premium: 1,
            forSale: 1,
            unavailable: 18,
        },
        dealScoreBand: 'medium',
        demandBand: 'medium',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Motion',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'active',
        spellingRisk: 'low',
    },
    {
        id: 'preview-lumen-dev',
        domain: 'lumen.dev',
        tld: 'dev',
        status: 'available',
        askPrice: 940,
        renewal: 14,
        source: 'Registrar',
        resellPrice: 2420,
        spread: 1480,
        compsRepartition: {
            available: 5,
            premium: 2,
            forSale: 0,
            unavailable: 17,
        },
        dealScoreBand: 'medium',
        demandBand: 'medium',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Clean',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'bright',
        spellingRisk: 'low',
    },
    {
        id: 'preview-vertex-ai',
        domain: 'vertex.ai',
        tld: 'ai',
        status: 'premium',
        askPrice: 4820,
        renewal: 85,
        source: 'Marketplace',
        resellPrice: 10840,
        spread: 6020,
        compsRepartition: {
            available: 2,
            premium: 3,
            forSale: 1,
            unavailable: 25,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Technical',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'sharp',
        spellingRisk: 'low',
    },
    {
        id: 'preview-harbor-co',
        domain: 'harbor.co',
        tld: 'co',
        status: 'available',
        askPrice: 1765,
        renewal: 28,
        source: 'Registrar',
        resellPrice: 4120,
        spread: 2355,
        compsRepartition: {
            available: 4,
            premium: 1,
            forSale: 1,
            unavailable: 20,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Trusted',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'safe',
        spellingRisk: 'low',
    },
    {
        id: 'preview-forge-io',
        domain: 'forge.io',
        tld: 'io',
        status: 'resell',
        askPrice: 3260,
        renewal: 42,
        source: 'Marketplace',
        resellPrice: 6910,
        spread: 3650,
        compsRepartition: {
            available: 2,
            premium: 2,
            forSale: 2,
            unavailable: 21,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Industrial',
        syllables: 1,
        partOfSpeech: 'noun',
        sentiment: 'strong',
        spellingRisk: 'low',
    },
    {
        id: 'preview-catalyst-app',
        domain: 'catalyst.app',
        tld: 'app',
        status: 'available',
        askPrice: 2190,
        renewal: 18,
        source: 'Registrar',
        resellPrice: 4980,
        spread: 2790,
        compsRepartition: {
            available: 3,
            premium: 2,
            forSale: 0,
            unavailable: 23,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Growth',
        syllables: 3,
        partOfSpeech: 'noun',
        sentiment: 'energetic',
        spellingRisk: 'low',
    },
    {
        id: 'preview-vault-co',
        domain: 'vault.co',
        tld: 'co',
        status: 'premium',
        askPrice: 2985,
        renewal: 28,
        source: 'Marketplace',
        resellPrice: 6720,
        spread: 3735,
        compsRepartition: {
            available: 2,
            premium: 3,
            forSale: 1,
            unavailable: 22,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Secure',
        syllables: 1,
        partOfSpeech: 'noun',
        sentiment: 'stable',
        spellingRisk: 'low',
    },
    {
        id: 'preview-pulse-ai',
        domain: 'pulse.ai',
        tld: 'ai',
        status: 'available',
        askPrice: 3890,
        renewal: 85,
        source: 'Registrar',
        resellPrice: 8790,
        spread: 4900,
        compsRepartition: {
            available: 3,
            premium: 2,
            forSale: 1,
            unavailable: 24,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Signal',
        syllables: 1,
        partOfSpeech: 'noun',
        sentiment: 'dynamic',
        spellingRisk: 'low',
    },
    {
        id: 'preview-anchor-dev',
        domain: 'anchor.dev',
        tld: 'dev',
        status: 'available',
        askPrice: 1180,
        renewal: 14,
        source: 'Registrar',
        resellPrice: 2870,
        spread: 1690,
        compsRepartition: {
            available: 5,
            premium: 1,
            forSale: 0,
            unavailable: 18,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Reliable',
        syllables: 2,
        partOfSpeech: 'noun',
        sentiment: 'grounded',
        spellingRisk: 'low',
    },
    {
        id: 'preview-prism-io',
        domain: 'prism.io',
        tld: 'io',
        status: 'premium',
        askPrice: 2740,
        renewal: 42,
        source: 'Marketplace',
        resellPrice: 5840,
        spread: 3100,
        compsRepartition: {
            available: 3,
            premium: 2,
            forSale: 1,
            unavailable: 20,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'low',
        wordStyle: 'Visual',
        syllables: 1,
        partOfSpeech: 'noun',
        sentiment: 'clear',
        spellingRisk: 'low',
    },
    {
        id: 'preview-mosaic-app',
        domain: 'mosaic.app',
        tld: 'app',
        status: 'available',
        askPrice: 1560,
        renewal: 18,
        source: 'Registrar',
        resellPrice: 3520,
        spread: 1960,
        compsRepartition: {
            available: 4,
            premium: 1,
            forSale: 1,
            unavailable: 19,
        },
        dealScoreBand: 'high',
        demandBand: 'high',
        brandabilityBand: 'high',
        risk: 'medium',
        wordStyle: 'Creative',
        syllables: 3,
        partOfSpeech: 'noun',
        sentiment: 'collaborative',
        spellingRisk: 'low',
    },
    {
        id: 'preview-ember-io',
        domain: 'ember.io',
        tld: 'io',
        status: 'resell',
        askPrice: 2935,
        renewal: 42,
        source: 'Marketplace',
        resellPrice: 6400,
        spread: 3465,
    },
    {
        id: 'preview-merit-io',
        domain: 'merit.io',
        tld: 'io',
        status: 'available',
        askPrice: 4328,
        renewal: 42,
        source: 'Registrar',
        resellPrice: 8900,
        spread: 4572,
    },
    {
        id: 'preview-lattice-ai',
        domain: 'lattice.ai',
        tld: 'ai',
        status: 'available',
        askPrice: 3483,
        renewal: 85,
        source: 'Registrar',
        resellPrice: 7100,
        spread: 3617,
    },
    {
        id: 'preview-cobalt-co',
        domain: 'cobalt.co',
        tld: 'co',
        status: 'premium',
        askPrice: 1763,
        renewal: 28,
        source: 'Marketplace',
        resellPrice: 3800,
        spread: 2037,
    },
    {
        id: 'preview-aurora-com',
        domain: 'aurora.com',
        tld: 'com',
        status: 'available',
        askPrice: 12695,
        renewal: 12,
        source: 'Registrar',
        resellPrice: 26200,
        spread: 13505,
    },
];
